import Vue from 'vue'

export const store = Vue.observable({
  activeModal: false,
  activeModalFirstLogin: false
})
export const mutation = {
  setActiveModal: (activeModal) => {
    store.activeModal = activeModal
  },
  setActiveModalFirstLogin: (activeModal) => {
    store.activeModalFirstLogin = activeModal
  }
}